import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    TranslatedString,
    PrimaryButton,
} from '@bosch/bt-ui';

import './PathfinderInfo.css';
import withErrorHandler from '../../../components/ErrorHandler';

const PathfinderInfo = (props) => {
    const {
        token,
        isLoggedIn,
        searchPhysicalPanelId,
        physicalPanelIdErrorMsg,
        pathfinderInfoExternalResult,
        getPathfinderInfo,
        setPathfinderUpdateStatus
    } = props;

    const navigate = useNavigate();

    const handleSearch = useCallback(
        () => {
            if (token?.token) {
                if(isLoggedIn()) {
                    setPathfinderUpdateStatus(null)
                    getPathfinderInfo('GET', SUPPORTCONSOLE_API_URL + '/api/panelenvironment/v1/' + encodeURIComponent(searchPhysicalPanelId) + '/pathfinder', null, undefined, { 'Authorization': 'Bearer ' + token.token });
                }
                else {
                    navigate('/');
                }
            }
        },
        [searchPhysicalPanelId, getPathfinderInfo, token.token, isLoggedIn, navigate]
    );

    const MqttInfo = (result) => {
        const data = result?.data;

        if (data == null) {
            return <div><TranslatedString stringId="not-found"/></div>
        } else {
            return (
            <pre>
                <code>{JSON.stringify(result?.data, null, 2)}</code>
            </pre>
            );
        }
    }

    return (
        <div id="pathfinder-info" >
            <div className="pathfinder-info">
                <div><TranslatedString stringId="query-panel-mqtt-environment" /></div>
                <PrimaryButton
                    onClick={handleSearch}
                    disabled={searchPhysicalPanelId.length == 0 || !!physicalPanelIdErrorMsg}
                >
                    <TranslatedString stringId="button-search" />
                </PrimaryButton>
            </div>
            <div className='panel-mqtt-info'>
                <TranslatedString stringId="currently" />:
               { pathfinderInfoExternalResult && MqttInfo(pathfinderInfoExternalResult) }
            </div>
        </div>
    );
};

export default withErrorHandler(React.memo(PathfinderInfo));